import { CheckCircle2, CircleAlert, Info, MinusCircle } from "lucide-react";

export function SectionHeading({ eyebrow, title, description, actions }) {
  return (
    <header className="section-heading">
      <div>
        {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
        <h2>{title}</h2>
        {description ? <p>{description}</p> : null}
      </div>
      {actions ? <div className="section-heading__actions">{actions}</div> : null}
    </header>
  );
}

export function Field({
  label,
  value,
  onChange,
  type = "text",
  step,
  min,
  max,
  placeholder,
  hint,
  disabled = false,
}) {
  return (
    <label className="field">
      <span>{label}</span>
      <input
        type={type}
        value={value ?? ""}
        onChange={(event) => onChange?.(
          type === "number"
            ? event.target.value === "" ? null : Number(event.target.value)
            : event.target.value,
        )}
        step={step}
        min={min}
        max={max}
        placeholder={placeholder}
        disabled={disabled}
      />
      {hint ? <small>{hint}</small> : null}
    </label>
  );
}

export function SelectField({ label, value, onChange, options, hint }) {
  return (
    <label className="field">
      <span>{label}</span>
      <select value={value ?? ""} onChange={(event) => onChange?.(event.target.value)}>
        {options.map(([optionValue, optionLabel]) => (
          <option key={optionValue} value={optionValue}>{optionLabel}</option>
        ))}
      </select>
      {hint ? <small>{hint}</small> : null}
    </label>
  );
}

export function TextAreaField({ label, value, onChange, rows = 4, placeholder, hint }) {
  return (
    <label className="field">
      <span>{label}</span>
      <textarea
        value={value ?? ""}
        onChange={(event) => onChange?.(event.target.value)}
        rows={rows}
        placeholder={placeholder}
      />
      {hint ? <small>{hint}</small> : null}
    </label>
  );
}

export function Metric({ label, value, detail, status = "neutral" }) {
  return (
    <div className={`metric metric--${status}`}>
      <span>{label}</span>
      <strong>{value}</strong>
      {detail ? <small>{detail}</small> : null}
    </div>
  );
}

const statusIcons = {
  favorable: CheckCircle2,
  attention: CircleAlert,
  review: CircleAlert,
  neutral: Info,
  unavailable: MinusCircle,
};

export function StatusNote({ status = "neutral", title, children }) {
  const Icon = statusIcons[status] ?? Info;
  return (
    <div className={`status-note status-note--${status}`}>
      <Icon aria-hidden="true" />
      <div>
        <strong>{title}</strong>
        <p>{children}</p>
      </div>
    </div>
  );
}

export function EmptyValue() {
  return <span className="empty-value">Pendiente</span>;
}

